import { updateSlotsBudget } from './utils/manageBudgetSlots';
import { generatePowerSuplies } from './utils/manageRouterSlots';
import { findIndex } from 'lodash';
import { IStore } from './types/index';
import { IBudget } from './types/store/budget';

const changeRegion = (state: IStore, newRegion: string) => ({
  budget: { ...state.budget, region: newRegion }
});

const updateSlotsWithNumber = (state: IStore, slotItemID: string, qty: number) => {
  const copyBudget = { ...state.budget };
  copyBudget.slots.front.slotsSpecs = updateSlotsBudget(
    state.slotsItems[slotItemID],
    state.routerData.slots.front.slotsSpecs,
    [...state.budget.slots.front.slotsSpecs],
    qty
  );

  copyBudget.slots.back.slotsSpecs = generatePowerSuplies(
    copyBudget.slots.front.slotsSpecs,
    copyBudget.slots.back.slotsSpecs,
    state.slotsItems,
    state.routerData
  );

  return { budget: copyBudget };
};

const updatePowerSupply = (state: IStore, selectedPowerSupplyID: string) => {
  const copyBudget = { ...state.budget };

  copyBudget.slots.back.slotsSpecs =
    selectedPowerSupplyID === 'none' || selectedPowerSupplyID === undefined
      ? []
      : [{ name: state.routerData.slots.back.slotsSpecs[0].name, filled: selectedPowerSupplyID }];

  return { budget: copyBudget };
};

const updateProSupport = (state: IStore, selectedProSupport: string) => {
  const copyBudget = { ...state.budget };

  copyBudget.proSupport = Object.keys(state.routerData.proSupport).reduce((proSupportObj, key) => {
    proSupportObj[key] = false;
    return proSupportObj;
    // tslint:disable-next-line:align
  }, {});
  copyBudget.proSupport[selectedProSupport] = selectedProSupport !== 'none' ? true : false;

  return { budget: copyBudget };
};

const setRedundantSupply = (state: IStore, needRedundantSupply: string) => {
  const copyBudget = { ...state.budget };

  copyBudget.slots.back.slotsSpecs =
    needRedundantSupply === 'true'
      ? [
          ...copyBudget.slots.back.slotsSpecs,
          {
            name: state.routerData.slots.back.slotsSpecs[1].name,
            filled: copyBudget.slots.back.slotsSpecs[0].filled
          }
        ]
      : [copyBudget.slots.back.slotsSpecs[0]];

  return { budget: copyBudget };
};

const setSlotRouterItemFront = (state: IStore, slotRouterName: string, slotItemName: string) => {
  const frontSlots = state.budget.slots.front.slotsSpecs;
  const positionNameRouterSlot = findIndex(frontSlots, ['name', slotRouterName]);
  const routerSlotExist = positionNameRouterSlot !== -1;

  const addItem = () => frontSlots.push({ name: slotRouterName, filled: slotItemName });
  const editItem = () => (frontSlots[positionNameRouterSlot].filled = slotItemName);
  const removeItem = () => routerSlotExist && frontSlots.splice(positionNameRouterSlot, 1);

  slotItemName ? (routerSlotExist ? editItem() : addItem()) : removeItem();

  state.budget.slots.front.slotsSpecs = frontSlots;
  state.budget.slots.back.slotsSpecs = generatePowerSuplies(
    state.budget.slots.front.slotsSpecs,
    state.budget.slots.back.slotsSpecs,
    state.slotsItems,
    state.routerData
  );

  return { budget: { ...state.budget } };
};

export type IChangeRegion = (newRegion: string) => { budget: IBudget };

export type IUpdateSlotsWithNumber = (
  slotItemID: string,
  qty: number
) => {
  budget: IBudget;
};
export type IUpdatePowerSupply = (
  selectedPowerSupplyID: string
) => {
  budget: IBudget;
};
export type IUpdateProSupport = (
  selectedProSupport: string
) => {
  budget: IBudget;
};
export type ISetRedundantSupply = (
  needRedundantSupply: string
) => {
  budget: IBudget;
};
export type ISetSlotRouterItemFront = (
  slotRouterName: string,
  slotItemName: string
) => {
  budget: IBudget;
};

export interface IActions {
  changeRegion: IChangeRegion;
  updateSlotsWithNumber: IUpdateSlotsWithNumber;
  updatePowerSupply: IUpdatePowerSupply;
  updateProSupport: IUpdateProSupport;
  setRedundantSupply: ISetRedundantSupply;
  setSlotRouterItemFront: ISetSlotRouterItemFront;
}

export default (store: IStore) => ({
  changeRegion: changeRegion,
  updateSlotsWithNumber: updateSlotsWithNumber,
  updatePowerSupply: updatePowerSupply,
  updateProSupport: updateProSupport,
  setRedundantSupply: setRedundantSupply,
  setSlotRouterItemFront: setSlotRouterItemFront
});



// WEBPACK FOOTER //
// ./src/actions.ts